import { Component, QueryList, ViewChildren,OnInit,ViewChild,ElementRef,VERSION } from '@angular/core';
import { Observable } from 'rxjs';
import { Validators, FormBuilder, FormGroup, FormControl,FormArray } from '@angular/forms';
// import { count } from 'rxjs/operators';
// export interface Time {
import { HttpClient,HttpHeaders,HttpRequest, HttpEventType, HttpResponse,HttpErrorResponse } from '@angular/common/http';
import { map, catchError } from 'rxjs/operators';
import { ActivatedRoute, Router } from '@angular/router';
import { formatDate } from "@angular/common";
import { NgbNavChangeEvent } from '@ng-bootstrap/ng-bootstrap';
import { NgbActiveModal, NgbModal, ModalDismissReasons, NgbModalConfig } from '@ng-bootstrap/ng-bootstrap';
import { DropzoneConfigInterface } from 'ngx-dropzone-wrapper';
import { Gallery, GalleryItem, ImageItem, ThumbnailsPosition, ImageSize } from 'ng-gallery';
import { Lightbox } from 'ng-gallery/lightbox';
import {CdkDragDrop, CdkDropList, CdkDrag, moveItemInArray} from '@angular/cdk/drag-drop';
import {NgFor} from '@angular/common';
//import * as ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { environment } from 'src/environments/environment';
import { LoaderService } from 'src/app/loader.service';
import { UploadService } from './upload.service';
import { AngularEditorConfig } from '@kolkov/angular-editor';

// }
@Component({
  selector: 'app-signupProcessSeller',
  templateUrl: './signupProcessSeller.component.html',
  styleUrls: ['./signupProcessSeller.component.scss'],    
})
export class SignupProcessSellerComponent{
  seconds: number;
  headers1 = new HttpHeaders({ 'Content-Type': 'application/json','API_KEY':'20e20m06i16e14r31p','Version':'1.0' });    	 
  opt = { headers: this.headers1 };
  head=new HttpHeaders({'Accept': 'application/json','Access-Control-Allow-Origin': '*','Content-Type': 'multipart/form-data'});
  option = { headers: this.head };
  token:any;
  vendor:any;
  qval:any;
  items: GalleryItem[];
  
  country:any;
  countryshort:any;
   
  
  
  public config2: DropzoneConfigInterface = {
    clickable: true,
    maxFiles: 5,
    autoReset: null,
    errorReset: null,
    cancelReset: null
  };
  
	rows: FormArray;
	pForm: FormGroup;
	brandForm: FormGroup;
	vForm: FormGroup;	
	uploadForm: FormGroup;
	registerForm : FormGroup;	
	billingForm: FormGroup;		
	cForm: FormGroup;
	priceForm: FormGroup;	
	priceAfterForm: FormGroup;
	PIForm: FormGroup;
	manuForm: FormGroup;
	vdForm: FormGroup;
	vModelForm: FormGroup;
	vEditModelForm: FormGroup;
	vClosedModelForm: FormGroup;
	discountForm: FormGroup;
	bModelForm: FormGroup;
	bEditModelForm: FormGroup;
	
	businessTypes: any;
	countries : any;
	countryProvinces: any;	
	products: any;
	productsList: any;
	submitted: boolean = false;
	next2Clicked: boolean = false;
	next3Clicked: boolean = false;
	next4Clicked: boolean = false;
	next5Clicked: boolean = false;
	next6Clicked: boolean = false;
	next7Clicked: boolean = false;
	next8Clicked: boolean = false;
	next9Clicked: boolean = false;
	next10Clicked: boolean = false;
	next11Clicked: boolean = false;
	next12Clicked: boolean = false;
	next13Clicked: boolean = false;
	next14Clicked: boolean = false;
	next15Clicked: boolean = false;	
	next16Clicked: boolean = false;	
	pFormClicked: boolean = false;	
	vFormClicked: boolean = false;	
	manuFormClicked: boolean = false;	
	priceFormClicked: boolean = false;	
	priceAfterFormClicked: boolean = false;	
	PIFormClicked: boolean = false;	
	vModelFormClicked: boolean = false;	
	onBModelClicked: boolean = false;
	vdFormClicked: boolean = false;
	vEditModelFormClicked: boolean = false;
	vClosedModelFormClicked: boolean = false;	
	discountFormClicked: boolean = false;
	bModelFormClicked: boolean = false;
	bEditModelFormClicked: boolean = false;
	minDobString:any;
	maxDobString:any;
	statelong:any;	
	
	@ViewChild('dis_per') dis_per: ElementRef;
	
	rows1:any[];
	
	val:any;
	
	userDetails:any;
	selectedFiles: FileList;
	selectedFilesAbout: FileList;
	selectedPI: FileList;

	imgResult: string = '';
	closeResult: string;
	
	prd_list:any;
	data1:any;
	
	//Form1
	company_po_id:any;	
	seller_id:any;
	cbusiness_type:any;
	cbusiness_vertical_name:any;
	cbusiness_vertical_description:any;
	cbusiness_name:any;
	cbusiness_subdomain:any;
	clegal_name:any;
	caddressline1:any;
	caddressline2:any;
	cstreet_no:any;
	cstreet_name:any;
	carea_name:any;
	cregion_name:any;
	czip:any;
	cstateshort:any;
	cadmin_first_name:any;
	cadmin_last_name:any;
	cadmin_gender:any;
	cadmin_dob:any;
	cadmin_title:any;
	cadmin_phone:any;
	cadmin_email:any;
	
	
	
	
	//Form2
	summary_image_url='';
	registration_number:any;
	registration_date:any;							
	pan_number:any;
	phone:any;
	office_email:any;
	accounts_email:any;
	accounts_phone:any;
	web_url:any;
	insta:any;	
	linkedin:any;
	password_renewal_days:any;			
	enquiry_email:any;
	monthly_purchase_minimum:any;
	maximum_products:any;
	billing_addressline1:any;
	billing_addressline2:any;
	billing_street_no:any;
	billing_street_name:any;
	billing_area:any;
	billing_region:any;
	billing_zip:any;
	billing_stateshort:any;
	gstin_number:any;
	public about_us_text='';
	about_us_image_url:any;
	terms_conditions:any;
	level1_name:any;
	level2_name:any;
	
	l1Categories:any=[];
	l2Categories:any=[];
	l3Categories:any=[];
	brands:any=[];
	manus:any=[];
	banners:any=[];
	collections:any=[];
	productImages:any=[];
	
	
	prod_id:any;
	edit_prod_id:any=null;
	edit_action:any=null;
	prod_brand: any="";
	prod_name: any;
	prod_colour: any;							
	prod_model: any;
	prod_pack: any;										
	prod_description: any;
	prod_specifications: any;
	category1_id: any="";
	category2_id: any="";			
	category3_id: any="";	
	manu_id:any="";
	
	prod_varient_enabled=false;
	prod_varient_header: any;	
	prod_varient_display_type: any;			
	cgst: any;
	sgst: any;
	igst: any;
	cls:any;		
	
	product_price:any;
	discount_percentage:any;
	enable_special_offer:any;
	special_offer_percentage=30;
	special_offer_start_date:any;
	special_offer_end_date:any;
	special_offer_infinite:any;
	
	varients:any;
	varient_id:any;
	
	R2SummaryImagesURL:any;
	R2DetailsURL:any;
	R2HomeURL:any;
	
	gift_wrapping_price=30;
	gift_wrapping_priceM=30;
	gift_wrapping_enabled:any;
	
	enable_bundle_discounts:boolean=false;
	
	enable_volume_discounts:boolean=false;
	slab1_gte='5';
	slab2_gte='10';
	slab3_gte='15';
	slab4_gte='20';
	slab1_disc_percentage:any;
	slab2_disc_percentage:any;
	slab3_disc_percentage:any;
	slab4_disc_percentage:any;
	slab1_disable: boolean = true;
	slab2_disable: boolean = true;
	slab3_disable: boolean = true;
	slab4_disable: boolean = true;
	country_origin:any;
	hsn_code:any;
	
	
	varient_idEdit:any;
	short_nameEdit:any;
	long_nameEdit:any;
	product_priceEdit:any;
	default_priceEdit:any;
	gift_wrapping_enabledEdit:any;
	gift_wrapping_priceEdit:any;
	display_order_idEdit:any;
	item_not_availableEdit:any;
	
	varient_id_closed:any;
	bundleproducts:any;
	
	bundle_id_edit:any;
	prod_id_edit:any;
	bundle_offer_percentage_edit:any;
	order_id_edit:any;
	
	giftM="display:none";
	
	sku_seller: any;
	sku_sellerM: any;
	sku_sellerEdit: any;
	
	
	editorConfig: AngularEditorConfig = {
    editable: true,
	spellcheck: true,
      height: '200px',
      minHeight: '0',
      maxHeight: 'auto',
      width: 'auto',
      minWidth: '0',
      translate: 'yes',
      enableToolbar: true,
      showToolbar: true,
      placeholder: 'Enter text here...',
      defaultParagraphSeparator: '',
      defaultFontName: '',
      defaultFontSize: '',
      fonts: [
        {class: 'arial', name: 'Arial'},
        {class: 'times-new-roman', name: 'Times New Roman'},
        {class: 'calibri', name: 'Calibri'},
        {class: 'comic-sans-ms', name: 'Comic Sans MS'}
      ],
      customClasses: [
      {
        name: 'quote',
        class: 'quote',
      },
      {
        name: 'redText',
        class: 'redText'
      },
      {
        name: 'titleText',
        class: 'titleText',
        tag: 'h1',
      },
    ],	
    };  

  public htmlContent = '';
	
	
  
  constructor(private http: HttpClient,private route: ActivatedRoute,private router: Router,private formBuilder: FormBuilder,config: NgbModalConfig, private modalService: NgbModal,public gallery: Gallery, public lightbox: Lightbox,private uploadService: UploadService,private loadingService: LoaderService) {    
	config.backdrop = 'static';
    config.keyboard = false;
	this.rows = this.formBuilder.array([]);
  }

  
	selectFile(event) 
	{
				
		if(event.target.files.item(0).type=='image/png' || event.target.files.item(0).type=='image/jpeg' || event.target.files.item(0).type=='image/webp')
		{
				
			if(event.target.files.item(0).size<512000)
			{
				this.selectedFiles = event.target.files;			
			}
			else
			{
				alert("File Size Less then 512kb");
				this.pForm.controls['summary_image_url'].setValue("");
			}
		}
		else
		{
			alert("Only allowed PNG or JPG or WEBP");
			this.pForm.controls['summary_image_url'].setValue("");		
		}				
		
	}
	
	selectFilePI(event) 
	{
		//alert(event.target.files.item(0));	
		if(event.target.files.item(0).type=='image/png' || event.target.files.item(0).type=='image/jpeg' || event.target.files.item(0).type=='image/webp')
		{
			//this.selectedPI = event.target.files;		
			if(event.target.files.item(0).size<256000)
			{
				this.selectedPI = event.target.files;		
			}
			else
			{
				alert("File Size Less then 256kb");
				this.PIForm.controls['images_url'].setValue("");	
			}
		}
		else
		{
			alert("Only allowed PNG or JPG or WEBP");
			this.PIForm.controls['images_url'].setValue("");		
		}
			
		
		
	}
	
	onEnableVarient(e)
	{
		const checkbox = document.getElementById('prod_varient_enabled',) as HTMLInputElement | null;
		var element1 = window.document.getElementById("price")!;		
		var element2 = window.document.getElementById("varient")!;		
		var element3 = window.document.getElementById("varient1")!;		
		if (checkbox?.checked)
		{		 
		  element1.style.display="none";
		  element2.style.display="block";
		  element3.style.display="none";
		  this.prod_varient_enabled=true;
		} 
		else
		{
		  element1.style.display="block";
		  element2.style.display="none";
		  element3.style.display="block";
		  this.prod_varient_enabled=false;
		}

	}
	
	onEnable(e)
	{
		const checkbox = document.getElementById('special_offer',) as HTMLInputElement | null;
		var element1 = window.document.getElementById("s_offer")!;		
		if (checkbox?.checked)
		{		 
		  element1.style.display="block";
		} 
		else
		{
		  element1.style.display="none";
		}

	}
	
	onEnableGift(e)
	{
		
		const checkbox = document.getElementById('gift_wrapping_enabled',) as HTMLInputElement | null;
		var element1 = window.document.getElementById("gift")!;		
		if (checkbox?.checked)
		{		 				
		  element1.style.display="block";
		} 
		else
		{
		  element1.style.display="none";
		}

	}
	
	onEnableGiftM(e)
	{
		
		const checkbox = document.getElementById('mgift_wrapping_enabled',) as HTMLInputElement | null;
		var element1 = window.document.getElementById("mgift")!;		
		if (checkbox?.checked)
		{		 				
		  element1.style.display="block";
		} 
		else
		{
		  element1.style.display="none";
		}

	}
	
	onEnableVD(e)
	{
		
		const checkbox = document.getElementById('vd',) as HTMLInputElement | null;
		var element1 = window.document.getElementById("vdf")!;		
		if (checkbox?.checked)
		{
		  this.enable_volume_discounts=true;	
		  element1.style.display="block";
		} 
		else
		{
			this.enable_volume_discounts=false;	
			element1.style.display="none";
		}

	}
	
	onEnableEBD(e)
	{
		
		const checkbox = document.getElementById('ebd',) as HTMLInputElement | null;
		var element1 = window.document.getElementById("bd")!;		
		if (checkbox?.checked)
		{
		  this.enable_bundle_discounts=true;	
		  element1.style.display="block";
		} 
		else
		{
			this.enable_bundle_discounts=false;	
			element1.style.display="none";
		}

	}
	
	enableSlab()
	{
		this.slab1_gte='';
		this.slab2_gte='';
		this.slab3_gte='';
		this.slab4_gte='';
		this.slab1_disable=false;
		this.slab2_disable=false;
		this.slab3_disable=false;
		this.slab4_disable=false;
	}
	
	onDiscount(e)
	{
		
		if(e.target.value>20)
		{
			alert("Please enter 1% to 20%");
			this.priceForm.controls['discount_percentage'].setValue("");
			this.dis_per.nativeElement.focus();
			
		}

	}
	
	onEnable1(e)
	{
		
		const checkbox = document.getElementById('special_offer1',) as HTMLInputElement | null;
		var element1 = window.document.getElementById("s_offer1")!;		
		if (checkbox?.checked)
		{		 
		  element1.style.display="block";
		} 
		else
		{
		  element1.style.display="none";
		}

	}
	
	
	onInfinite(e)
	{
		const checkbox1 = document.getElementById('special_offer_infinite',) as HTMLInputElement | null;
		var element1 = window.document.getElementById("infinite")!;
		
		if (checkbox1?.checked)
		{		 		
		  element1.style.display="none";
		} 
		else
		{		 
		  element1.style.display="block";
		}

	}
	
	
	onInfinite1(e)
	{
		const checkbox1 = document.getElementById('special_offer_infinite1',) as HTMLInputElement | null;
		var element1 = window.document.getElementById("infinite1")!;
		
		if (checkbox1?.checked)
		{		 		
		  element1.style.display="none";
		} 
		else
		{		 
		  element1.style.display="block";
		}

	}
	
	
	getCategory2(event) 
	{
		if(event.target.value!='')
		{
			this.http.post(environment.api_url+'/auth/login', {"username": "john", "password": "changeme"},this.opt).subscribe((response) => 
			{
					this.token=response;
				
					let h = new HttpHeaders({ 'Content-Type': 'application/json','Authorization':'Bearer '+this.token.access_token,'Access-Control-Allow-Origin': "*" });    	 
					let o = { headers: h };										
					
					this.http.get(environment.api_url+'/v1/l2CategoryPO/level1_id/'+event.target.value,o).subscribe((response) => 
					{						
						this.l2Categories=response;	
						
					});
					
										
			});	
		}
		
	}
	
	
	getCategory3(event) 
	{
		if(event.target.value!='')
		{
			this.http.post(environment.api_url+'/auth/login', {"username": "john", "password": "changeme"},this.opt).subscribe((response) => 
			{
					this.token=response;			
					let h = new HttpHeaders({ 'Content-Type': 'application/json','Authorization':'Bearer '+this.token.access_token,'Access-Control-Allow-Origin': "*" });    	 
					let o = { headers: h };										
					
					this.http.get(environment.api_url+'/v1/l3CategoryPO/level2_id/'+event.target.value,o).subscribe((response) => 
					{	
						
						this.l3Categories=response;	
						
					});												
			});	
		}
		
	}
	
	getCountry(tr)
	{		
	  this.country=tr.target.options[tr.target.options.selectedIndex].text;	  	 
	 
	}
	
	getManu(tr)
	{	
		
	  var element1 = window.document.getElementById("origin")!;	
		
	  if(tr.target.value=='')
	  {					 		
		element1.style.display="block";		
	  }
	  else
	  {
			this.http.post(environment.api_url+'/auth/login', {"username": "john", "password": "changeme"},this.opt).subscribe((response) => 
			{
					this.token=response;			
					let h = new HttpHeaders({ 'Content-Type': 'application/json','Authorization':'Bearer '+this.token.access_token,'Access-Control-Allow-Origin': "*" });    	 
					let o = { headers: h };										
					
					this.http.get(environment.api_url+'/v1/companySellerManu/'+tr.target.value,o).subscribe((response) => 
					{	
						
						this.countryshort=response[0].countryshort;	
						this.country=response[0].country;	
						
					});												
			});	
		  element1.style.display="none";
	  }
	 
	}
	
	removeBundle(id) 
	{

		if (confirm('Are you sure you want to delete?')) 
		{
			this.http.post(environment.api_url+'/auth/login', {"username": "john", "password": "changeme"},this.opt).subscribe((response) => 
			{
				this.token=response;		
				let h = new HttpHeaders({ 'Content-Type': 'application/json','Authorization':'Bearer '+this.token.access_token,'Access-Control-Allow-Origin': "*" });    	 
				let o = { headers: h };																		
				
				this.http.delete(environment.api_url+'/v1/companySellerProdBundle/'+id,o).subscribe((re) => 
				{								
						var datatable = $('#bundleproductTable').DataTable();
						datatable.destroy();
						this.http.get(environment.api_url+'/v1/companySellerProdBundle/prod_id/'+this.prod_id,o).subscribe((response) => 
						{						
							this.bundleproducts=response;
							setTimeout(()=>{ 
							$('#bundleproductTable').DataTable( {
							  pagingType: 'full_numbers',
							  pageLength: 5,
							  processing: true,
							  lengthMenu : [5, 10, 25],
							  dom: '<"pull-left"f><"pull-right"l>tip',
							} );	
							}, 1);
						});												
				});				
			});
		} else {
		  // Do nothing!
		 // console.log('Thing was not saved to the database.');
		}
							
	}
	
	
	slab1()
	{
		this.slab1_disable=true;
	}
	
	slab2(e)
	{
		var val=this.vdForm.controls['slab1_gte'].value;
		
		if(parseInt(e.target.value)<=val)
		{
			alert("Please Enter value Greatter then Slab 1");
			this.vdForm.controls['slab2_gte'].setValue("");
			
		}
		else
		{	
			this.slab2_disable=true;
		}
	}
	
	slab3(e)
	{
		var val=this.vdForm.controls['slab2_gte'].value;
		if(parseInt(e.target.value)<=val)
		{
			alert("Please Enter value Greatter then Slab 2");
			this.vdForm.controls['slab3_gte'].setValue("");	
			
		}
		else
		{	
			this.slab3_disable=true;
		}
	}
	
	slab4(e)
	{
		var val=this.vdForm.controls['slab3_gte'].value;
		if(parseInt(e.target.value)<=val)
		{
			alert("Please Enter value Greatter then Slab 3");
			this.vdForm.controls['slab4_gte'].setValue("");	
			
		}
		else
		{	
			this.slab4_disable=true;
		}
	}

  public ngOnInit() 
  { 
  
		//this.countryshort = environment.defaultCountryId;
		//this.country = environment.defaultCountryId;
		this.R2SummaryImagesURL=environment.R2SummaryImages;
		this.R2DetailsURL=environment.R2Details;
		this.R2HomeURL=environment.R2Home;
		
		this.cls='display:none;';
		
		this.company_po_id=localStorage.getItem('company_po_id');
		this.cbusiness_name=localStorage.getItem('business_name');
		this.cbusiness_subdomain=localStorage.getItem('business_subdomain');
		

		let dat = new Date().toISOString();
		
		var yearMS = 365 * (1000 * 60 * 60 * 24); // 365 days
		var now = new Date().getTime();		
		var minDobMS = now - (122.5 * yearMS);		
		this.minDobString = new Date(minDobMS).toISOString().slice(0, 10);
		var eighteenYearsAgo = new Date();
		var eighteenYearsAgo1 = eighteenYearsAgo.setFullYear(eighteenYearsAgo.getFullYear()-18);
		this.maxDobString =new Date(eighteenYearsAgo1).toISOString().slice(0, 10);					
		
		
		
		
		this.qval = this.route
		.queryParams
		.subscribe(params => {
		// Defaults to 0 if no query param provided.
		this.val = +params['val'] || 0;
		this.prod_id=params['id'];
		this.nextUrl(this.val-1);			
		
		});		
		
				
	
		
		var userDetails = JSON.parse(localStorage.getItem("userDetails") || '{}');
		//alert(JSON.stringify(userDetails));
		this.seller_id=userDetails.seller_id;
		this.cadmin_first_name=userDetails.first_name;
		this.cadmin_last_name=userDetails.last_name;
		this.cadmin_gender=userDetails.gender;
		this.cadmin_dob=formatDate(userDetails.dob.toString(),'yyyy-MM-dd','en-US');
		this.cadmin_title=userDetails.title;
		this.cadmin_phone=userDetails.phone;				
		this.cadmin_email=userDetails.email_id;
		//alert(this.seller_id);
		//Form2 Fetch Details
		this.http.post(environment.api_url+'/auth/login', {"username": "john", "password": "changeme"},this.opt).subscribe((response) => 
		{
				this.token=response;
			
				let h = new HttpHeaders({ 'Content-Type': 'application/json','Authorization':'Bearer '+this.token.access_token,'Access-Control-Allow-Origin': "*" });    	 
				let o = { headers: h };
						
				this.http.get(environment.api_url+'/v1/country',o).subscribe((response) => 
				{ 	
					this.countries=response;			
							
				});
				
				this.http.get(environment.api_url+'/v1/countryProvince/Country/'+environment.defaultCountryId,o).subscribe((response) => 
				{ 					
					this.countryProvinces=response;			
							
				});
				
				
				if(this.company_po_id!='' || this.company_po_id!=undefined)
				{
					this.http.get(environment.api_url+'/v1/companyBrand/company_po_id/'+this.company_po_id,o).subscribe((response) => 
					{													
						this.brands=response;						
					});

					
					
					this.http.get(environment.api_url+'/v1/l1CategoryPO/company_po_id/'+this.company_po_id,o).subscribe((response) => 
					{													
						this.l1Categories=response;
										
					});
				}				
				
				if(this.prod_id!=null)
				{
				this.http.get(environment.api_url+'/v1/companySellerProdLoc/'+this.prod_id,o).subscribe((response) => 
				{													
					this.products=response;					
					if(this.products.length>0)
					{					
					this.prod_id=response[0].prod_id;
					this.prod_brand=response[0].prod_brand;
					this.prod_name=response[0].prod_name;
					this.prod_colour=response[0].prod_colour;				
					this.prod_model=response[0].prod_model;
					this.prod_pack=response[0].prod_pack;							
					this.prod_description=response[0].prod_description;
					this.prod_specifications=response[0].prod_specifications;												
					this.category1_id=response[0].category1_id;
					this.summary_image_url=response[0].summary_image_url;
					this.enable_bundle_discounts=response[0].enable_bundle_discounts;
					
					
					//alert(response[0].category1_id);
					this.http.get(environment.api_url+'/v1/l2CategoryPO/level1_id/'+response[0].category1_id,o).subscribe((response) => 
					{						
						this.l2Categories=response;	
						
					});
					this.category2_id=response[0].category2_id;
					this.http.get(environment.api_url+'/v1/l3CategoryPO/level2_id/'+response[0].category2_id,o).subscribe((response) => 
					{	
						
						this.l3Categories=response;	
						
					});	
					this.category3_id=response[0].category3_id;											
					this.prod_varient_enabled=response[0].prod_varient_enabled;							
					this.cgst=response[0].cgst;					
					this.sgst=response[0].sgst;
					this.igst=response[0].igst;
					this.hsn_code=response[0].hsn_code;
					}
									
				});	
								
				this.http.get(environment.api_url+'/v1/companySellerProdVarient/AllowVarient/'+this.prod_id,o).subscribe((response) => 
				{						
					this.varients=response;
					setTimeout(()=>{ 
						$('#varients').DataTable( {
						  pagingType: 'full_numbers',
						  pageLength: 5,							  
						  lengthMenu : [5, 10, 25],
						  dom: '<"pull-left"f><"pull-right"l>tip',
						} );	
					}, 1);  
				});
				//alert(this.prod_id);
				this.http.get(environment.api_url+'/v1/companySellerProdImage/prod_id/'+this.prod_id,o).subscribe((response) => 
				{					
					this.productImages=response;		
					//alert(this.productImages);
				});
				
				this.http.get(environment.api_url+'/v1/companySellerProdBundle/prod_id/'+this.prod_id,o).subscribe((response) => 
				{						
					this.bundleproducts=response;
					setTimeout(()=>{ 
					$('#bundleproductTable').DataTable( {
					  pagingType: 'full_numbers',
					  pageLength: 5,
					  processing: true,
					  lengthMenu : [5, 10, 25],
					  dom: '<"pull-left"f><"pull-right"l>tip',
					} );	
					}, 1);
				});
				}
				
				this.http.get(environment.api_url+'/v1/companySellerManu/seller_id/'+this.seller_id,o).subscribe((response) => 
				{													
					this.manus=response;																		
				});	
				
				this.http.get(environment.api_url+'/v1/companySellerProdLoc/seller_id/'+this.seller_id+'/'+this.prod_id,o).subscribe((response) => 
				{										
					this.productsList=response;					
				});	
				
				
									
		});	
		
		
		
		this.brandForm = this.formBuilder.group({            
			brand_name: ['', Validators.required],			
        });
		
		this.manuForm = this.formBuilder.group({            
			manu_name: ['', Validators.required],
			addressline1: [''],
			addressline2: [''],			
			street_no: [''],
			street_name: [''],			
			area_name: [''],			
			region_name: [''],			
			zip: [''],		
			stateshort: [''],
			countryshort: ['', Validators.required]
        });
		
		this.pForm = this.formBuilder.group({            
			prod_brand: [''],
			prod_name: ['', Validators.required],
			prod_colour: [''],							
			prod_model: [''],
			prod_pack: [''],										
			prod_description: [''],	
			prod_specifications: [''],	
			category1_id: [''],	
			category2_id: [''],			
			category3_id: [''],
			manu_id: [''],
			summary_image_url: [''],
			country_origin: [''],
        });
		
		this.vForm = this.formBuilder.group({            							
			cgst: ['', Validators.required],
			sgst: ['', Validators.required],
			igst: ['', Validators.required],
			hsn_code: [''],	
			sku_seller: [''],	
        });
		
		this.vdForm = this.formBuilder.group({            
			enable_volume_discounts: [''],					
			slab1_gte: ['', Validators.required],
			slab2_gte: ['', Validators.required],
			slab3_gte: ['', Validators.required],			
			slab4_gte: ['', Validators.required],
			slab1_disc_percentage: ['', Validators.required],
			slab2_disc_percentage: ['', Validators.required],			
			slab3_disc_percentage: ['', Validators.required],
			slab4_disc_percentage: ['', Validators.required]
        });
		
		this.vEditModelForm = this.formBuilder.group({            
			short_nameEdit: ['',Validators.required],	
			long_nameEdit: ['',Validators.required],
			product_priceEdit: ['',Validators.required],
			sku_sellerEdit:[''],
			default_priceEdit:[''],
			gift_wrapping_enabledEdit: [''],
			gift_wrapping_priceEdit: [''],
			display_order_idEdit: ['',Validators.required],
			item_not_availableEdit: ['']
        });
		
		
		this.vClosedModelForm = this.formBuilder.group({            
			closed_reason: ['',Validators.required],			
        });
		
		this.bModelForm = this.formBuilder.group({            			
			bundle_id: ['',Validators.required],				
			bundle_offer_percentage: ['',Validators.required],
			order_id: ['',Validators.required],	
        });
		
		this.bEditModelForm = this.formBuilder.group({            			
			bundle_id_edit: ['',Validators.required],			
			bundle_offer_percentage_edit: ['',Validators.required],
			order_id_edit: ['',Validators.required],			
		});					
		
		this.priceForm = this.formBuilder.group({            
			product_price: [''],			
			gift_wrapping_enabled: [''],
			gift_wrapping_price: [''],				
        });
		
		
		this.discountForm = this.formBuilder.group({            						
			discount_percentage: [''],	
			enable_special_offer: [''],	
			special_offer_percentage: [''],	
			special_offer_start_date: [''],	
			special_offer_end_date: [''],	
			special_offer_infinite: [''],				
        });
		
		
		this.vModelForm = this.formBuilder.group({            
			short_name: ['',Validators.required],	
			long_name: ['',Validators.required],
			product_price: ['',Validators.required],			
			default_price: [''],
			sku_sellerM: [''],			
			gift_wrapping_enabled: [''],
			gift_wrapping_priceM: [''],
			display_order_id: ['',Validators.required],			
        });
		
		this.PIForm = this.formBuilder.group({            
			images_url:['',Validators.required],	
			order_id: ['',Validators.required],					
        });
											
		
		
	}
  
		
  
  
		get addDynamicRow() 
		{
			return this.registerForm.get('rows') as FormArray;
		}

		onAddRow() 
		{
			this.rows.push(this.createItemFormGroup());
			this.rows1=JSON.parse(JSON.stringify(this.rows.value));
			//console.log(JSON.parse(JSON.stringify(this.rows.value)));
		}

		onRemoveRow(rowIndex:number)
		{			
			this.rows.removeAt(rowIndex);	
			this.rows1=JSON.parse(JSON.stringify(this.rows.value));
		}

		createItemFormGroup(): FormGroup 
		{
			return this.formBuilder.group({
				title: [null],
				description: [null]		
			});
		}
		
		drop(event: CdkDragDrop<string[]>) 
		{			
			moveItemInArray(this.rows1, event.previousIndex, event.currentIndex);
		}
		
		openLg(content) 
		{
			this.modalService.open(content, { size: 'lg' });
		}
  
		openVerticallyCentered(content) 
		{
			this.rows1=JSON.parse(JSON.stringify(this.rows.value));
			this.modalService.open(content, { centered: true });
		}
		
		
		openLgVarient(content,id) 
		{			
			this.http.post(environment.api_url+'/auth/login', {"username": "john", "password": "changeme"},this.opt).subscribe((response) => 
			{
				this.token=response;
				let h = new HttpHeaders({ 'Content-Type': 'application/json','Authorization':'Bearer '+this.token.access_token,'Access-Control-Allow-Origin': "*" });    	 
				let o = { headers: h };
				
				this.http.get(environment.api_url+'/v1/companySellerProdVarient/varient_id/'+id,o).subscribe((res) => 
				{
					this.varient_idEdit=id;					
					this.short_nameEdit=res[0].short_name;										
					this.long_nameEdit=res[0].long_name;
					this.product_priceEdit=res[0].product_price;
					this.default_priceEdit=res[0].default_price;
					this.sku_sellerEdit=res[0].sku_seller;
					this.gift_wrapping_enabledEdit=res[0].gift_wrapping_enabled;
					this.gift_wrapping_priceEdit=res[0].gift_wrapping_price;
					this.display_order_idEdit=res[0].display_order_id;
					if(this.gift_wrapping_enabled==true)
					{
						this.giftM="display:block";
					}
					else
					{
						this.giftM="display:none";
					}
					
				});
			});
			this.modalService.open(content, { size: 'lg' });
			
		}
		
		openLgVarientClosed(content,id) 
		{			
			this.varient_id_closed=id;
			this.modalService.open(content, { size: 'lg' });
			
		}
		
		
		openLgBundle(content,id) 
		{		
			this.http.post(environment.api_url+'/auth/login', {"username": "john", "password": "changeme"},this.opt).subscribe((response) => 
			{
				this.token=response;
				let h = new HttpHeaders({ 'Content-Type': 'application/json','Authorization':'Bearer '+this.token.access_token,'Access-Control-Allow-Origin': "*" });    	 
				let o = { headers: h };
				
				this.http.get(environment.api_url+'/v1/companySellerProdBundle/'+id,o).subscribe((res) => 
				{					
					//alert(JSON.stringify(res));
					this.bundle_id_edit=id;					
					this.order_id_edit=res[0].order_id;										
					this.bundle_offer_percentage_edit=res[0].bundle_offer_percentage;
					this.prod_id_edit=res[0].prod_id;
					
				});
			});
			this.modalService.open(content, { size: 'lg' });
			
		}
		
		
		onAdd()
		{			
			
				this.bModelFormClicked = true;			
				
				if (this.bModelForm.invalid) 
				{
					return;
				}	
						
				this.bModelForm.value.prod_id=this.prod_id;				
				//	alert(JSON.stringify(this.vModelForm.value))
			
				this.http.post(environment.api_url+'/auth/login', {"username": "john", "password": "changeme"},this.opt).subscribe((response) => 
				{
					this.token=response;
					let h = new HttpHeaders({ 'Content-Type': 'application/json','Authorization':'Bearer '+this.token.access_token,'Access-Control-Allow-Origin': "*" });    	 
					let o = { headers: h };
				
					this.http.post(environment.api_url+'/v1/companySellerProdBundle',this.bModelForm.value,o).subscribe((response) => 
					{	
							
							var datatable = $('#bundleproductTable').DataTable();
							datatable.destroy();
							this.http.get(environment.api_url+'/v1/companySellerProdBundle/prod_id/'+this.prod_id,o).subscribe((response) => 
							{						
								this.bundleproducts=response;
								setTimeout(()=>{ 
								$('#bundleproductTable').DataTable( {
								  pagingType: 'full_numbers',
								  pageLength: 5,
								  processing: true,
								  lengthMenu : [5, 10, 25],
								  dom: '<"pull-left"f><"pull-right"l>tip',
								} );	
								}, 1);
							});
							this.bModelForm.reset();
							this.bModelFormClicked=false;
							this.modalService.dismissAll();		
							
							//window.location.reload();									
							
					},(err: HttpErrorResponse) => {
					  if (err instanceof Error) 
					  {
					  
						alert(err.error.message);					
						//this.message = `An error occured ${err.error.message}`;
					  } 
					  else 
					  {					  										  
						alert(err.error.message);
						this.bModelForm.reset();
						this.bModelFormClicked=false;
						return;
					  }
					});
																
				});	
			
		
		}
				
		onEdit()
		{			
			
				this.bEditModelFormClicked = true;			
				
				if (this.bEditModelForm.invalid) 
				{
					return;
				}	
						
				this.bEditModelForm.value.prod_id_edit=this.prod_id;
								
			
				this.http.post(environment.api_url+'/auth/login', {"username": "john", "password": "changeme"},this.opt).subscribe((response) => 
				{
					this.token=response;
					let h = new HttpHeaders({ 'Content-Type': 'application/json','Authorization':'Bearer '+this.token.access_token,'Access-Control-Allow-Origin': "*" });    	 
					let o = { headers: h };
				
					this.http.put(environment.api_url+'/v1/companySellerProdBundle/'+this.bEditModelForm.value.bundle_id_edit,this.bEditModelForm.value,o).subscribe((response) => 
					{							
							var datatable = $('#bundleproductTable').DataTable();
							datatable.destroy();
							this.http.get(environment.api_url+'/v1/companySellerProdBundle/prod_id/'+this.prod_id,o).subscribe((response) => 
							{						
								this.bundleproducts=response;
								setTimeout(()=>{ 
								$('#bundleproductTable').DataTable( {
								  pagingType: 'full_numbers',
								  pageLength: 5,
								  processing: true,
								  lengthMenu : [5, 10, 25],
								  dom: '<"pull-left"f><"pull-right"l>tip',
								} );	
								}, 1);
							});							
							this.modalService.dismissAll();																
					},(err: HttpErrorResponse) => {
					  if (err instanceof Error) 
					  {
					  
						alert(err.error.message);					
						//this.message = `An error occured ${err.error.message}`;
					  } 
					  else 
					  {					  										  
						alert(err.error.message);						
						return;
					  }
					});
																
				});	
			
		
		}		
				
		
		
  
  
		public onUploadInit(args: any): void {  }

		public onUploadError(args: any): void {  }

		public onUploadSuccess(args: any): void {  }   
  
  
		getState(tr)
		{		
		  this.statelong=tr.target.options[tr.target.options.selectedIndex].text;	  	 
		 
		}
			
		showVarient(v)
		{
			if(this.vForm.controls['prod_varient_enabled'].value==false || this.vForm.controls['prod_varient_enabled'].value=='')
			{
				const element1 = window.document.getElementById("varient1")!;					
				element1.style.display="block";
				const element2 = window.document.getElementById("varient2")!;					
				element2.style.display="block";
			}			
			else
			{
				const element1 = window.document.getElementById("varient1")!;					
				element1.style.display="none";
				const element2 = window.document.getElementById("varient2")!;					
				element2.style.display="none";
			}
		}	
		
		
		clear()
		{
			
			this.pForm.reset();		
			this.router.navigate(['/master/AddProduct'],{ queryParams: { val: 1 } })	
		}
		
	
	async next(n)
	{
		
		 var step1 = window.document.getElementById("1")!;
		 var step2 = window.document.getElementById("2")!;
		 var step3 = window.document.getElementById("3")!;
		 var step4 = window.document.getElementById("4")!;
		 		 
		 if(n==1)
		 {		
			
				
							
				this.pFormClicked = true;
				if (this.pForm.invalid) 
				{
					
					return;
				}			
				this.pForm.value.company_id=this.company_po_id;		
				this.pForm.value.seller_id=this.seller_id;
				
				if(this.pForm.value.manu_id!='')
				{
				this.pForm.value.country_origin=this.countryshort
				}
				
				this.pForm.value.created_at=new Date().toISOString();
				if(this.pForm.value.category2_id=='')
				{
					this.pForm.value.category2_id=null;
				}
				
				if(this.pForm.value.category3_id=='')
				{
					this.pForm.value.category3_id=null;
				}		
				
				if(this.pForm.value.summary_image_url=='' && this.summary_image_url=='')
				{
					alert("Please Upload Product Image");
					return;
				}		
				
							
				
				
				if(this.pForm.value.summary_image_url!='')
				{
					try 
					{
						this.loadingService.setLoading(true);
						
						await this.uploadService.uploadProductSummary(this.selectedFiles.item(0),this.prod_id).then((res)=>
						{ 					
							this.pForm.value.summary_image_url=this.R2SummaryImagesURL+"/"+this.prod_id+"/"+res;
						}); 
					}catch (error) {
						// handle error message
					} finally {
					  this.loadingService.setLoading(false);
					}
				}		
				else
				{
					this.pForm.value.summary_image_url=this.summary_image_url;
				}
				
				
				
				
					
				this.http.post(environment.api_url+'/auth/login', {"username": "john", "password": "changeme"},this.opt).subscribe((response) => 
				{
					this.token=response;
					let h = new HttpHeaders({ 'Content-Type': 'application/json','Authorization':'Bearer '+this.token.access_token,'Access-Control-Allow-Origin': "*" });    	 
					let o = { headers: h };
				
					this.http.post(environment.api_url+'/v1/companySellerProdLoc/createSignup',this.pForm.value,o).subscribe((re) => 
					{	
						
						this.prod_id=re[0].prod_id;						
						this.router.navigate(['/auth/SignupProcessSeller'],{ queryParams: { val: 2,id:re[0].prod_id  } });	
						
					},(err: HttpErrorResponse) => {
					  if (err instanceof Error) 
					  {
					  
						alert(err.error.message);					
						//this.message = `An error occured ${err.error.message}`;
					  } 
					  else 
					  {					  										  
						alert(err.error.message);
						return;
					  }
					});
																
				});	
				

					
			//this.seller.nativeElement.focus();
			
		 }		
		 else if(n==2)
		 {					 			
			this.router.navigate(['/auth/SignupProcessSeller'],{ queryParams: { val: 3,id:this.prod_id } });
			
		 }		 
		 else if(n==3)
		 {	
				
				const checkbox = document.getElementById('prod_varient_enabled',) as HTMLInputElement | null;				
				if (checkbox?.checked)
				{		 
				  if(this.varients.length==0)
				  {
					alert("Please Add One Varient");
					return;
				  }
				} 
				else
				{
					if(this.priceForm.value.product_price==undefined )
					{
						alert("Please Enter Product Price");
						return;
					}
				}
											
				
				this.vFormClicked = true;
				if (this.vForm.invalid) 
				{
					return;
				}
				
				
				
				this.priceForm.value.prod_id=this.prod_id;
				this.priceForm.value.company_po_id=this.company_po_id;
				this.priceForm.value.prod_varient_enabled=this.prod_varient_enabled;				
				this.priceForm.value.seller_id=this.seller_id;	
				
				
				          							
				this.priceForm.value.cgst=this.vForm.value.cgst;
				this.priceForm.value.sgst=this.vForm.value.sgst;
				this.priceForm.value.igst=this.vForm.value.igst;
				this.priceForm.value.hsn_code=this.vForm.value.hsn_code;
				this.priceForm.value.sku_seller=this.vForm.value.sku_seller;
				
			
        		//alert(JSON.stringify(this.priceForm.value));
				
					this.loadingService.setLoading(true);
					await this.http.post(environment.api_url+'/auth/login', {"username": "john", "password": "changeme"},this.opt).subscribe((response) => 
					{
						this.token=response;
						let h = new HttpHeaders({ 'Content-Type': 'application/json','Authorization':'Bearer '+this.token.access_token,'Access-Control-Allow-Origin': "*" });    	 
						let o = { headers: h };
					
						this.http.post(environment.api_url+'/v1/companySellerProdLoc/page3Signup',this.priceForm.value,o).subscribe((response) => 
						{									
							this.loadingService.setLoading(false);
							this.router.navigate(['/auth/SignupProcessSeller'],{ queryParams: { val: 4,id:this.prod_id } });	
													
								
						},(err: HttpErrorResponse) => {
						  if (err instanceof Error) 
						  {
						  
							alert(err.error.message);					
							//this.message = `An error occured ${err.error.message}`;
						  } 
						  else 
						  {					  										  
							alert(err.error.message);
							return;
						  }
						});
																	
					});								
																									
		}
		else if(n==4)		
		{
							
				if(this.discountForm.value.enable_special_offer==true)
				{
					//alert(this.priceForm.value.special_offer_start_date);
					if(this.discountForm.value.special_offer_start_date==undefined)
					{
						alert("Please Enter Start Date");
						return;
					}
					
					if(this.discountForm.value.special_offer_infinite==undefined || this.priceForm.value.special_offer_infinite==false)
					{
						if(this.discountForm.value.special_offer_end_date==undefined)
						{
							alert("Please Enter End Date");
							return;
						}
					
					}
				
				}		

				if(this.enable_bundle_discounts==true)
				{
					if(this.bundleproducts.length==0)
					{
						alert("Please Add One Bundle Product or Disable the Bundle Discount");
						return;
					}
					
					this.discountForm.value.enable_bundle_discounts=true;
					
				}
				else
				{
					this.discountForm.value.enable_bundle_discounts=false;
				}
				
				
				
				if(this.enable_volume_discounts==true)
				{
					this.discountForm.value.enable_volume_discounts=true;
					this.vdFormClicked = true;				
					if (this.vdForm.invalid) 
					{
						return;
					}
				}
				
				
				
				if(this.discountForm.value.enable_special_offer==undefined)
				{
					this.discountForm.value.enable_special_offer=false;
				}	
				
				if(this.discountForm.value.special_offer_infinite==undefined)
				{
					this.discountForm.value.special_offer_infinite=false;
				}
				
				
				
				
				
				
				this.discountForm.value.prod_id=this.prod_id;
				this.discountForm.value.company_po_id=this.company_po_id;
				this.discountForm.value.seller_id=this.seller_id;
				
				this.discountForm.value.enable_bundle_discounts=this.enable_bundle_discounts;
				this.discountForm.value.enable_volume_discounts=this.enable_volume_discounts;
				this.discountForm.value.slab1_gte=this.vdForm.value.slab1_gte;
				this.discountForm.value.slab2_gte=this.vdForm.value.slab2_gte;
				this.discountForm.value.slab3_gte=this.vdForm.value.slab3_gte;
				this.discountForm.value.slab4_gte=this.vdForm.value.slab4_gte;
				this.discountForm.value.slab1_disc_percentage=this.vdForm.value.slab1_disc_percentage;
				this.discountForm.value.slab2_disc_percentage=this.vdForm.value.slab2_disc_percentage;
				this.discountForm.value.slab3_disc_percentage=this.vdForm.value.slab3_disc_percentage;
				this.discountForm.value.slab4_disc_percentage=this.vdForm.value.slab4_disc_percentage;
				
				this.loadingService.setLoading(true);				
				//alert(JSON.stringify(this.discountForm.value));
				this.http.post(environment.api_url+'/auth/login', {"username": "john", "password": "changeme"},this.opt).subscribe((response) => 
				{
					this.token=response;
					let h = new HttpHeaders({ 'Content-Type': 'application/json','Authorization':'Bearer '+this.token.access_token,'Access-Control-Allow-Origin': "*" });    	 
					let o = { headers: h };
					
					this.http.post(environment.api_url+'/v1/companySellerProdLoc/page4SignUp',this.discountForm.value,o).subscribe((response) => 
					{									
							this.loadingService.setLoading(false);
								this.router.navigate(['/master/ViewProduct']);							
							
					},(err: HttpErrorResponse) => {
					  if (err instanceof Error) 
					  {
					  
						alert(err.error.message);					
						//this.message = `An error occured ${err.error.message}`;
					  } 
					  else 
					  {					  										  
						alert(err.error.message);
						return;
					  }
					});
																
				});			
		}
	}
	
	back(n)
	{		
		 if(n==1)
		 {			
			this.router.navigate(['/auth/SignupProcessSeller'],{ queryParams: { val: 1,id:this.prod_id } })	
		 }
		 else if(n==2)
		 {			
			this.router.navigate(['/auth/SignupProcessSeller'],{ queryParams: { val: 2,id:this.prod_id } })	
		 }
		 else if(n==3)
		 {			
			this.router.navigate(['/auth/SignupProcessSeller'],{ queryParams: { val: 3,id:this.prod_id } })	
		 }		 
		 	
	}
	
	nextUrl(n)
	{
	
		var step1 = window.document.getElementById("1")!;
		var step2 = window.document.getElementById("2")!;
		var step3 = window.document.getElementById("3")!;
		var step4 = window.document.getElementById("4")!;
		
		
		
		var element1 = window.document.getElementById("form1")!;
		var element2 = window.document.getElementById("form2")!;
		var element3 = window.document.getElementById("form3")!;
		var element4 = window.document.getElementById("form4")!;
		
		
		 if(n==0)
		 {		 										
			element1.style.display="block";
			element2.style.display="none";
			element3.style.display="none";
			element4.style.display="none";
			
			step1.className="u-pearl current col-3";
			step2.className="u-pearl done col-3";
			step3.className="u-pearl done col-3";
			step4.className="u-pearl done col-3";
			
		 }
		 else if(n==1)
		 {		 										
			element1.style.display="none";
			element2.style.display="block";
			element3.style.display="none";
			element4.style.display="none";
			
			step1.className="u-pearl done col-3";
			step2.className="u-pearl current col-3";
			step3.className="u-pearl done col-3";
			step4.className="u-pearl done col-3";
			
		 }
		 else if(n==2)
		 {		 								
			element1.style.display="none";
			element2.style.display="none";
			element3.style.display="block";
			element4.style.display="none";
			
			step1.className="u-pearl done col-3";
			step2.className="u-pearl done col-3";
			step3.className="u-pearl current col-3";
			step4.className="u-pearl done col-3";
			
		 }
		 else if(n==3)
		 {		 								
			element1.style.display="none";
			element2.style.display="none";
			element3.style.display="none";
			element4.style.display="block";
			
			step1.className="u-pearl done col-3";
			step2.className="u-pearl done col-3";
			step3.className="u-pearl done col-3";
			step4.className="u-pearl current col-3";
			
		 }	
		
		
		 
	}
	
	
	
	onPage3()
	{
			
				this.vModelFormClicked = true;			
				
				if (this.vModelForm.invalid) 
				{
					return;
				}	
				this.vModelForm.value.prod_varient_enabled=true;
				this.vModelForm.value.varient_id=this.prod_id;			
				this.vModelForm.value.prod_id=this.prod_id;
				this.vModelForm.value.sku_seller=this.vModelForm.value.sku_sellerM;
				
				if(this.vModelForm.value.default_price==undefined)
				{
					this.vModelForm.value.default_price='false';
				}
				
				if(this.vModelForm.value.gift_wrapping_enabled==undefined)
				{
					this.vModelForm.value.gift_wrapping_enabled='false';									
					this.vModelForm.value.gift_wrapping_price=0;
				}
				
				
							
			
				this.http.post(environment.api_url+'/auth/login', {"username": "john", "password": "changeme"},this.opt).subscribe((response) => 
				{
					this.token=response;
					let h = new HttpHeaders({ 'Content-Type': 'application/json','Authorization':'Bearer '+this.token.access_token,'Access-Control-Allow-Origin': "*" });    	 
					let o = { headers: h };
				
					this.http.post(environment.api_url+'/v1/companySellerProdLoc/onPage3',this.vModelForm.value,o).subscribe((response) => 
					{									
							var datatable = $('#varients').DataTable();
							datatable.destroy();
							this.http.get(environment.api_url+'/v1/companySellerProdVarient/AllowVarient/'+this.prod_id,o).subscribe((response) => 
							{						
								this.varients=response;
								setTimeout(()=>{ 
									$('#varients').DataTable( {
									  pagingType: 'full_numbers',
									  pageLength: 5,										 
									  lengthMenu : [5, 10, 25],
									  dom: '<"pull-left"f><"pull-right"l>tip',
									} );	
								}, 1); 
							});
							this.vModelForm.reset();
							this.vModelFormClicked=false;
							this.modalService.dismissAll();		
						//	window.location.reload();									
							
					},(err: HttpErrorResponse) => {
					  if (err instanceof Error) 
					  {
					  
						alert(err.error.message);					
						//this.message = `An error occured ${err.error.message}`;
					  } 
					  else 
					  {					  										  
						alert(err.error.message);
						return;
					  }
					});
																
				});	
			
		
	}
	
	
	onPage3Edit()
	{
			
				this.vEditModelFormClicked = true;			
				
				if (this.vEditModelForm.invalid) 
				{
					return;
				}	
				
				this.vEditModelForm.value.varient_id=this.varient_idEdit;			
				this.vEditModelForm.value.prod_id=this.prod_id;
				
				if(this.vEditModelForm.value.default_priceEdit==undefined)
				{
					this.vEditModelForm.value.default_priceEdit='false';
				}
				
				if(this.vEditModelForm.value.gift_wrapping_enabledEdit==undefined)
				{
					this.vEditModelForm.value.gift_wrapping_enabledEdit='false';									
					this.vEditModelForm.value.gift_wrapping_priceEdit=0;
				}							
							
			
				this.http.post(environment.api_url+'/auth/login', {"username": "john", "password": "changeme"},this.opt).subscribe((response) => 
				{
					this.token=response;
					let h = new HttpHeaders({ 'Content-Type': 'application/json','Authorization':'Bearer '+this.token.access_token,'Access-Control-Allow-Origin': "*" });    	 
					let o = { headers: h };
				
					this.http.post(environment.api_url+'/v1/companySellerProdLoc/varientEdit',this.vEditModelForm.value,o).subscribe((response) => 
					{								
							var datatable = $('#varients').DataTable();
							datatable.destroy();
							this.http.get(environment.api_url+'/v1/companySellerProdVarient/AllowVarient/'+this.prod_id,o).subscribe((response) => 
							{						
								this.varients=response;								
								setTimeout(()=>{ 
								$('#varients').DataTable( {
								pagingType: 'full_numbers',
								pageLength: 5,	
								  /*data: this.varients,
								  columns:
								  [
									{ "data": "display_order_id" },							   	
									{								
										data: null,
										className: 'text-center',
										searchable: false,
										orderable: false,
										render: function (data, type, full, meta) {
											if(data.default_price==true)
											{
												return '<i class="fa fa-check-square" style="color:#143fef"></i>';
											}
											else
											{
												return '<i class="fa fa-square-o" style="color:#143fef"></i>';
											}
											
										}			
									},
									{ "data": "short_name" },
									{ "data": "long_name" },
									{ "data": "product_price" },
									{								
										data: null,
										className: 'text-center',
										searchable: false,
										orderable: false,
										render: function (data, type, full, meta) {
											if(data.gift_wrapping_enabled==true)
											{
												return '<i class="fa fa-check-square" style="color:#143fef"></i>';
											}
											else
											{
												return '<i class="fa fa-square-o" style="color:#143fef"></i>';
											}
											
										}			
									},							
									{ "data": "gift_wrapping_price" },
								  ],*/
							  lengthMenu : [5, 10, 25],
							  dom: '<"pull-left"f><"pull-right"l>tip',
							} );	
							}, 1);  
							});
							this.vEditModelForm.reset();
							this.vEditModelFormClicked=false;
							this.modalService.dismissAll();		
						//	window.location.reload();									
							
					},(err: HttpErrorResponse) => {
					  if (err instanceof Error) 
					  {
					  
						alert(err.error.message);					
						//this.message = `An error occured ${err.error.message}`;
					  } 
					  else 
					  {					  										  
						alert(err.error.message);
						return;
					  }
					});
																
				});	
			
		
	}
	
	onPageClosed(e)
	{		
				this.vClosedModelFormClicked = true;			
				
				if (this.vClosedModelForm.invalid) 
				{
					return;
				}	
				
				this.vClosedModelForm.value.varient_id=this.varient_id_closed;			
				this.vClosedModelForm.value.closed=true;
							
				//alert(JSON.stringify(this.vClosedModelForm.value));
				this.http.post(environment.api_url+'/auth/login', {"username": "john", "password": "changeme"},this.opt).subscribe((response) => 
				{
					this.token=response;
					let h = new HttpHeaders({ 'Content-Type': 'application/json','Authorization':'Bearer '+this.token.access_token,'Access-Control-Allow-Origin': "*" });    	 
					let o = { headers: h };
				
					this.http.post(environment.api_url+'/v1/companySellerProdLoc/varientClosed',this.vClosedModelForm.value,o).subscribe((response) => 
					{								
							var datatable = $('#varients').DataTable();
							datatable.destroy();
							this.http.get(environment.api_url+'/v1/companySellerProdVarient/AllowVarient/'+this.prod_id,o).subscribe((response) => 
							{						
								this.varients=response;								
								setTimeout(()=>{ 
								$('#varients').DataTable( {
									pagingType: 'full_numbers',
									pageLength: 5,									 
									lengthMenu : [5, 10, 25],
									dom: '<"pull-left"f><"pull-right"l>tip',
									} );	
								}, 1);  
							});
							this.vEditModelForm.reset();
							this.vEditModelFormClicked=false;
							this.modalService.dismissAll();		
						//	window.location.reload();									
							
					},(err: HttpErrorResponse) => {
					  if (err instanceof Error) 
					  {
					  
						alert(err.error.message);					
						//this.message = `An error occured ${err.error.message}`;
					  } 
					  else 
					  {					  										  
						alert(err.error.message);
						return;
					  }
					});
																
				});	
			
		
	}
	
	onPageEnbled(id)
	{			
				this.http.post(environment.api_url+'/auth/login', {"username": "john", "password": "changeme"},this.opt).subscribe((response) => 
				{
					this.token=response;
					let h = new HttpHeaders({ 'Content-Type': 'application/json','Authorization':'Bearer '+this.token.access_token,'Access-Control-Allow-Origin': "*" });    	 
					let o = { headers: h };
				
					this.http.post(environment.api_url+'/v1/companySellerProdLoc/varientEnbled',{"id":id},o).subscribe((response) => 
					{								
							var datatable = $('#varients').DataTable();
							datatable.destroy();
							this.http.get(environment.api_url+'/v1/companySellerProdVarient/AllowVarient/'+this.prod_id,o).subscribe((response) => 
							{						
								this.varients=response;								
								setTimeout(()=>{ 
								$('#varients').DataTable( {
									pagingType: 'full_numbers',
									pageLength: 5,									 
									lengthMenu : [5, 10, 25],
									dom: '<"pull-left"f><"pull-right"l>tip',
									} );	
								}, 1);  
							});
						//	window.location.reload();									
							
					},(err: HttpErrorResponse) => {
					  if (err instanceof Error) 
					  {
					  
						alert(err.error.message);					
						//this.message = `An error occured ${err.error.message}`;
					  } 
					  else 
					  {					  										  
						alert(err.error.message);
						return;
					  }
					});
																
				});	
			
		
	}
	
	onBrandModel()
	{
		this.onBModelClicked = true;
		if (this.brandForm.invalid) 
		{
			return;
		}	
		
		this.brandForm.value.company_po_id=this.company_po_id;
		
		
		this.http.post(environment.api_url+'/auth/login', {"username": "john", "password": "changeme"},this.opt).subscribe((response) => 
		{
			this.token=response;
			let h = new HttpHeaders({ 'Content-Type': 'application/json','Authorization':'Bearer '+this.token.access_token,'Access-Control-Allow-Origin': "*" });    	 
			let o = { headers: h };
		
			this.http.post(environment.api_url+'/v1/companyBrand',this.brandForm.value,o).subscribe((response) => 
			{									
						this.http.get(environment.api_url+'/v1/companyBrand/company_po_id/'+this.company_po_id,o).subscribe((response) => 
						{													
							this.brands=response;																		
						});							
						this.modalService.dismissAll();							
						//window.location.reload();											
					
			},(err: HttpErrorResponse) => {
			  if (err instanceof Error) 
			  {
			  
				alert(err.error.message);					
				//this.message = `An error occured ${err.error.message}`;
			  } 
			  else 
			  {					  										  
				alert(err.error.message);
				return;
			  }
			});
														
		});	
	}
	
	
	onManuModel()
	{
		
		this.manuFormClicked = true;
		if (this.manuForm.invalid) 
		{
			return;
		}	
		
		this.manuForm.value.seller_id=this.seller_id;
		this.manuForm.value.company_id=this.company_po_id;
		
		//this.manuForm.value.countryshort=this.countryshort;
		this.manuForm.value.country=this.manuForm.value.countryshort;
		
		
		
		
		this.http.post(environment.api_url+'/auth/login', {"username": "john", "password": "changeme"},this.opt).subscribe((response) => 
		{
			this.token=response;
			let h = new HttpHeaders({ 'Content-Type': 'application/json','Authorization':'Bearer '+this.token.access_token,'Access-Control-Allow-Origin': "*" });    	 
			let o = { headers: h };
		
			this.http.post(environment.api_url+'/v1/companySellerManu',this.manuForm.value,o).subscribe((response) => 
			{									
						this.http.get(environment.api_url+'/v1/companySellerManu/seller_id/'+this.seller_id,o).subscribe((response) => 
						{													
							this.manus=response;																		
						});							
						this.modalService.dismissAll();							
						//window.location.reload();											
					
			},(err: HttpErrorResponse) => {
			  if (err instanceof Error) 
			  {
			  
				alert(err.error.message);					
				//this.message = `An error occured ${err.error.message}`;
			  } 
			  else 
			  {					  										  
				alert(err.error.message);
				return;
			  }
			});
														
		});	
	}


	async onPIModel()
	{
		this.PIFormClicked = true;
		if (this.PIForm.invalid) 
		{
			return;
		}	

			try 
			{
				this.loadingService.setLoading(true);
				
				await this.uploadService.uploadProductSummary(this.selectedPI.item(0),this.prod_id).then((res)=>
				{ 					
					this.PIForm.value.images_url=this.R2SummaryImagesURL+"/"+this.prod_id+"/"+res;
				});
									
			}catch (error) {
				// handle error message
			} finally {
			  this.loadingService.setLoading(false);
			}
					
		
					
						
			this.PIForm.value.prod_id=this.prod_id;		

			
			this.http.post(environment.api_url+'/auth/login', {"username": "john", "password": "changeme"},this.opt).subscribe((response) => 
			{
				this.token=response;
				let h = new HttpHeaders({ 'Content-Type': 'application/json','Authorization':'Bearer '+this.token.access_token,'Access-Control-Allow-Origin': "*" });    	 
				let o = { headers: h };
			
				this.http.post(environment.api_url+'/v1/companySellerProdImage',this.PIForm.value,o).subscribe((response) => 
				{																					
						
						alert("Product Image Added Successfully");
						this.modalService.dismissAll();		
						window.location.reload();		
				},(err: HttpErrorResponse) => {
				  if (err instanceof Error) 
				  {
				  
					alert(err.error.message);					
					//this.message = `An error occured ${err.error.message}`;
				  } 
				  else 
				  {					  										  
					alert(err.error.message);
					return;
				  }
				});
															
			});	
		
	}
	
	

}
